var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7782 9.5V0.5H19.2782V9.5H20.7782ZM0.934909 13.9588L0 12.75H1.52818H17.8138H18.3513L18.524 13.259L20.5282 19.1658L22.5323 13.259L22.705 12.75H23.2426H39.5282H41.0564L40.1215 13.9588L35.2782 20.2212V33.1667V33.6205L34.8762 33.831L21.2782 40.9538V41.7395L20.5282 41.3467L19.7782 41.7395V40.9538L6.18018 33.831L5.77818 33.6205V33.1667V20.2212L0.934909 13.9588ZM34.4395 18.7553L21.7384 20.2673L23.7801 14.25H38L34.5234 18.7453L34.4395 18.7553ZM6.533 18.7453L6.61684 18.7553L19.3179 20.2673L17.2763 14.25H3.05636L6.533 18.7453ZM21.2782 21.8327V39.2605L33.7782 32.7129V20.3446L21.2782 21.8327ZM19.7782 21.8327L7.27818 20.3446V32.7129L19.7782 39.2605V21.8327ZM12.4223 3.4926L14.0896 10.1426L12.6347 10.5074L10.9674 3.8574L12.4223 3.4926ZM8.05851 10.9697L5.05851 7.96967L3.99785 9.03033L6.99785 12.0303L8.05851 10.9697ZM28.634 3.4926L26.9667 10.1426L28.4217 10.5074L30.089 3.8574L28.634 3.4926ZM31.9978 10.9697L34.9978 7.96967L36.0585 9.03033L33.0585 12.0303L31.9978 10.9697Z",
    fill: "#FAF7F5"
  })));
}

export default SvgNewCart;